module.exports = __webpack_public_path__ + "fonts/triya-icon.fc2425c.woff2";